import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-32da9e50"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" 我的考核 ");

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 评议人评议 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_Head = _resolveComponent("Head");

  var _component_list = _resolveComponent("list");

  var _component_Tabs = _resolveComponent("Tabs");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "年度考核"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "text",
        class: _normalizeClass({
          btn_detail: _ctx.Data.topTabsIndex == 1
        }),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.handleTabsChange(0);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      }, 8, ["class"]), _createVNode(_component_el_button, {
        type: "text",
        class: _normalizeClass({
          btn_detail: _ctx.Data.topTabsIndex == 0
        }),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.handleTabsChange(1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }, 8, ["class"])])];
    }),
    _: 1
  }), _createVNode(_component_Tabs, {
    title: _ctx.Data.titleArr,
    onChangeOther: _ctx.tabsChange
  }, {
    content0: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_list, {
        ref: "table1",
        "tabs-index": 0,
        "top-tabs-index": _ctx.Data.topTabsIndex,
        "api-name": _ctx.Data.topTabsIndex == 0 ? 'getEvaluationSelfPage' : 'getEvaluationSecretaryPage'
      }, null, 8, ["top-tabs-index", "api-name"]), [[_vShow, _ctx.Data.tabsIndex == 0]])];
    }),
    content1: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_list, {
        ref: "table2",
        "tabs-index": 1,
        "top-tabs-index": _ctx.Data.topTabsIndex,
        "api-name": _ctx.Data.topTabsIndex == 0 ? 'getEvaluationSelfPage' : 'getEvaluationSecretaryPage'
      }, null, 8, ["top-tabs-index", "api-name"]), [[_vShow, _ctx.Data.tabsIndex == 1]])];
    }),
    _: 1
  }, 8, ["title", "onChangeOther"])], 64);
}